import sanitizeHtml from 'sanitize-html';

export const HTML_SANITIZATION_DEFAULTS: sanitizeHtml.IOptions = {
  ...sanitizeHtml.defaults,
  allowedSchemes: ['http', 'https'],
  allowedTags: [...sanitizeHtml.defaults.allowedTags, 'img'],
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    '*': ['style', 'class'],
  },
};
